// extracted by mini-css-extract-plugin
module.exports = {"home":"HomePage_home__1L4od","title":"HomePage_title__2SwkK","colRegister":"HomePage_colRegister__Gy2hc","colSearch":"HomePage_colSearch__2YVIf"};